import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Router from '@ember/routing/router';
import GoalModel from 'donor-elf-web/models/goal';
import CurrentUser from 'donor-elf-web/services/current-user';

export default class DashboardYtdController extends Controller {
  @service declare currentUser: CurrentUser;
  @service declare router: Router;

  get goal(): GoalModel {
    return this.model.goal;
  }

  get goalData() {
    return this.goal.goalData;
  }

  get showYtdAndExpectingChart() {
    return this.currentUser.organizationName.yl;
  }

  // if this changes, then update app/components/journal/dashboard/uco.ts as well
  get leftToRaiseAmount() {
    let leftToRaise =
      this.goal.goalAmount -
      this.goalData.given_amount -
      this.goalData.expected_amount;
    if (leftToRaise < 0) {
      leftToRaise = 0;
    }
    return leftToRaise;
  }

  @action
  handleGivenAndExpectingClicked() {
    this.router.transitionTo('funds.fund.ytd-given-expecting');
  }
}
